import { render, staticRenderFns } from "./DropAddModal.vue?vue&type=template&id=c84ee898&scoped=true&"
import script from "./DropAddModal.vue?vue&type=script&lang=js&"
export * from "./DropAddModal.vue?vue&type=script&lang=js&"
import style0 from "./DropAddModal.vue?vue&type=style&index=0&id=c84ee898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ee898",
  null
  
)

export default component.exports